export default __webpack_public_path__ + "static/6-c8df66d39df820c1fd3ef07be84656fc.png";